// extracted by mini-css-extract-plugin
export var centerText = "_4i-8";
export var container = "_4i-0";
export var doughnutContainer = "_4i-7";
export var legend = "_4i-a";
export var legendItemColorDisplay = "_4i-b";
export var legendItemLabel = "_4i-d";
export var legendItemValue = "_4i-c";
export var lg = "_4i-5";
export var maxWidth = "_4i-9";
export var md = "_4i-4";
export var responsive = "_4i-6";
export var sm = "_4i-3";
export var xs = "_4i-2";
export var xxs = "_4i-1";